// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
// ** Axios Imports
// import axios from "axios"

import { getAllFromController } from "@lib/api"

export const getData = createAsyncThunk("crmClientsToValidate/getData", async (params) => {
  const offset = (params.page - 1) * params.perPage
  const data = await getAllFromController(
    `Persons?filters[discriminator]=Person&offset=${offset}&sort[${params.sortColumn}]=${params.sort}&limit=${params.perPage}${
      params.statusId ? `&filters[statusId]=${params.statusId}` : ""
    }${params.q ? `&search=${params.q}` : ""}`
  )
  return {
    params,
    data: data.data,
    allData: data.data,
    totalPages: data.total
  }
})

export const crmClientsToValidate = createSlice({
  name: "crmClientsToValidate",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
  }
})

export default crmClientsToValidate.reducer
